<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'">
            {{ $t('key_footer_start_year')}} 
            {{ new Date().getFullYear() }}, {{ $t('key_footer_made_with_love') }} 
            <i class="fa fa-heart text-danger"></i> {{ $t('key_footer_by') }} 
            <a href="https://www.sevica.es" class="font-weight-bold text-primary" target="_blank">{{ $t('key_footer_company_name') }}</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
